import { getCnpjRoot } from './cnpj-utils'

/**
 * Regras de compatibilidade entre o CFOP selecionado e o destinatário, considerando o atributo
 * `onlyBetweenCompanyBranch` do CFOP (cadastrado em Cfop):
 * - Entre filiais (mesma raiz de CNPJ): somente CFOPs com `onlyBetweenCompanyBranch`
 * - Entre lojas (raízes de CNPJ diferentes): somente CFOPs sem `onlyBetweenCompanyBranch`.
 */
function isCfopCompatibleWithRecipient({
  issuerCnpj,
  recipientCnpj,
  cfopData,
}) {
  const { code: cfopCode, onlyBetweenCompanyBranch } = cfopData || {}

  if (!cfopCode || !issuerCnpj || !recipientCnpj) return true

  const isSameCompany = getCnpjRoot(issuerCnpj) === getCnpjRoot(recipientCnpj)

  if (isSameCompany) {
    return onlyBetweenCompanyBranch
  }

  return !onlyBetweenCompanyBranch
}

// CST e CSOSN de ICMS com Substituição Tributária (ST), conforme TaxCodeService.StTaxRateTypes do back
const stIcmsCodes = ['10', '30', '60', '70']
const stCsosnIcmsCodes = ['201', '202', '203', '500']

function isStIcms({ stIcms, csosnIcms } = {}) {
  return stIcmsCodes.includes(stIcms) || stCsosnIcmsCodes.includes(csosnIcms)
}

/**
 * CFOP do item conforme o ICMS ST do produto, usando o `cfopStCode` do CFOP (cadastrado em Cfop).
 * Ex: Natureza de Operação 5152 com `cfopStCode` 5409:
 * - item com ST (cerveja): 5409
 * - item sem ST (água): 5152
 * Se a Natureza de Operação for o CFOP de ST (5409), o item sem ST usa o CFOP de origem (5152).
 */
function getCfopByIcmsSt({ natureCfop, cfops, isSt }) {
  if (!natureCfop) return natureCfop

  if (isSt) {
    return cfops.find(c => c.code === natureCfop.cfopStCode) || natureCfop
  }

  return cfops.find(c => c.cfopStCode === natureCfop.code) || natureCfop
}

export {
  isCfopCompatibleWithRecipient as isCfopToSameCompanyBranch,
  isStIcms,
  getCfopByIcmsSt,
}
